import React from 'react'
import { Milo } from 'component-library/collections-new/Milo/Milo'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from 'component-library/collections-new/collections-props.routing'
import { LoadMore } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreProps } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { CardOrientationOptions } from 'component-library/cards/Portrait/Portrait'
import { FixedRatio } from 'common/client-data-types/image-item'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'

export interface MiloRouteProps extends CollectionRouteProps, LoadMoreProps {
    fixedRatios?: FixedRatio[]
    showLargeCard?: boolean
    largeCardPosition?: 'left' | 'right' | undefined
    largeCardSpan?: 2 | 3 | 4 | undefined
    largeCardType?: 'portrait' | 'landscape' | undefined

    largeCardHasBackground?: boolean
    disableImageLazyLoad?: boolean
    hideKicker?: boolean
    hideTeaser?: boolean
    hideByline?: boolean
    preserveOrderOnMobile?: boolean
    cardOrientation?: CardOrientationOptions
}

export const MiloRegistration = createRegisterableComponentWithData(
    'milo',
    ContentDataDefinitionLoader,
    (props: MiloRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={moreData => {
                    return (
                        <Milo
                            items={
                                moreData.loaded
                                    ? { loaded: true, result: moreData.result.publications }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs
                            )}
                            fixedRatios={props.fixedRatios}
                            sectionHeader={props.sectionHeader}
                            showLargeCard={props.showLargeCard}
                            largeCardPosition={props.largeCardPosition}
                            largeCardSpan={props.largeCardSpan}
                            largeCardType={props.largeCardType}
                            largeCardHasBackground={props.largeCardHasBackground}
                            verticalSpacing={props.verticalSpacing}
                            hideKicker={props.hideKicker}
                            hideTeaser={props.hideTeaser}
                            hideByline={props.hideByline}
                            preserveOrder={props.preserveOrderOnMobile}
                            disableImageLazyLoad={props.disableImageLazyLoad}
                            cardOrientation={props.cardOrientation}
                            onEvent={services.onEvent}
                        />
                    )
                }}
            />
        )
    }
)
